import * as endpoint from "src/assets/endpoint.json";
export const API_URI = endpoint.enpoint_url;
export const TAGID = localStorage.getItem('googletagid');
